import { render, staticRenderFns } from "./InformacoesClienteComponent.vue?vue&type=template&id=5e655f9c"
import script from "./InformacoesClienteComponent.vue?vue&type=script&lang=js"
export * from "./InformacoesClienteComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports